import { Box } from "@mui/material";
import { useCallback, useRef } from "react";
import { useIsMobile } from "src/hooks/useIsMobile";

interface Props {
  children: React.ReactNode;
  width?: string | number;
}

const ProductCarousel = ({ children, width }: Props) => {
  const isMobile = useIsMobile();
  const ref = useRef<HTMLDivElement | null>(null);

  const onMouseWheel = useCallback(
    (e: React.WheelEvent) => {
      if (isMobile) return;

      const el = ref.current;
      if (!el || e.shiftKey) return;

      const mostlyVertical = Math.abs(e.deltaY) > Math.abs(e.deltaX);
      if (!mostlyVertical) return;

      el.scrollLeft += e.deltaY;
    },
    [isMobile],
  );

  return (
    <Box
      ref={ref}
      onWheel={onMouseWheel}
      sx={{
        display: "flex",
        gap: 2,
        py: 1,
        overflowX: "auto",
        overflowY: "hidden",
        width,
        scrollSnapType: "x mandatory",
        "& > *": { scrollSnapAlign: "center" },
        overscrollBehavior: isMobile ? "" : "contain",
        WebkitOverflowScrolling: "touch",
        "::-webkit-scrollbar": {
          display: isMobile ? "none" : "",
          color: "black",
        },
      }}
    >
      {children}
    </Box>
  );
};

export default ProductCarousel;
